﻿{
  "createAccount": "Konto erstellen",
  "subscription": "Abonnement",
  "oneTimePurchase": "Vollversion",
  "billingDetails": "Rechnungsdaten",
  "paymentDetails": "Zahlungsdetails",
  "requestAQuote": "Antragsformular für Organisationen",
  "reviewOrder": "Bestellung überprüfen",
  "thankYouForYourOrder": "Vielen Dank für Ihre Bestellung!",
  "joinTheCommunity": "Der Community beitreten",
  "startTrial": "Test starten",
  "yourTrialHasEnded": "Ihr Test ist beendet.",
  "taxExempt": "Steuerbefreiung",
  "taxExemptThankYou": "Der Upload war erfolgreich!",
  "planDetails": "Meine Abonnementdetails",
  "modifyPlan": "Produkt ändern",
  "modifyPaymentDetails": "Zahlungsdaten ändern",
  "redirect": "Weiterleitung zu Boardmaker",
  "perpetualTrial": "{{trialLength}}-tägigen Test herunterladen",
  "perpetualThankYou": "Ihre Software ist bereit!",
  "downloads": "Herunterladen Boardmaker",
  "partner": "Partner finden",
  "intro": "Wählen Sie bitte eines der folgenden Boardmaker-Produkte, um die neueste Version für Ihr Gerät herunterzuladen.",
  "systemRequirements": "Systemanforderungen",
  "releaseNotes": "Versionshinweise",
  "comparison": "Abonnement und Lizenz vergleichen"
}
